import "@components/ag-grid/styles/AgCharts.css";
import { GetSystemSuccessRateResponseData } from "@services/models/Analytics/GetSystemSuccessRate";
import { formatDisplayDate } from "@utils/safeDate";
import { AgCharts } from "ag-charts-react";
import React, { useMemo } from "react";

type Props = {
  data: GetSystemSuccessRateResponseData[];
};

const SystemSuccessRateChart: React.FC<Props> = ({ data }) => {
  const chartData = useMemo(() => {
    return data
      .map((item) => ({
        date: formatDisplayDate(item.slot, "en-IN", {
          day: "numeric",
          month: "short",
        }),
        successRate: parseFloat(item.successRatePercent),
        slot: item.slot,
      }))
      .reverse();
  }, [data]);

  const chartOptions = useMemo(
    () =>
      ({
        data: chartData,
        series: [
          {
            type: "line",
            xKey: "date",
            yKey: "successRate",
            yName: "Success Rate (%)",
            stroke: "#81D1F4",
            marker: {
              fill: "#3B4CDB",
              stroke: "#81D1F4",
              size: 6,
            },
            strokeWidth: 2,
          },
        ],
        axes: [
          {
            type: "category",
            position: "bottom",
            title: {
              enabled: false,
            },
            label: {
              fontSize: 10,
              color: "var(--text-base)",
              rotation: 0,
            },
            line: {
              color: "transparent",
            },
            tick: {
              color: "transparent",
            },
            gridLine: {
              enabled: false,
            },
          },
          {
            type: "number",
            position: "left",
            title: {
              enabled: false,
            },
            label: {
              fontSize: 10,
              color: "var(--text-base)",
              formatter: (params: any) => `${params.value}%`,
            },
            line: {
              color: "transparent",
            },
            tick: {
              color: "transparent",
            },
            gridLine: {
              enabled: false,
            },
            min: 0,
          },
        ],
        background: {
          fill: "transparent",
        },
        padding: {
          top: 20,
          right: 20,
          bottom: 40,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          enabled: true,
          class: "ag-chart-tooltip-custom",
        },
      } as any),
    [chartData]
  );

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <AgCharts options={chartOptions} />
    </div>
  );
};

export default SystemSuccessRateChart;
